import React, { useState, useEffect, useContext } from 'react';
import { Spin, Card, Typography, Form, Input, Button, message } from 'antd';
import axios from 'axios';
import './QRCodeDisplay.css';
import { QRCodeContext } from '../context';

const { Title, Text } = Typography;
function wait(t){
  return new Promise((res, rej) => {
    setTimeout(e => res("done"), t)
  })
}
const QRCodeDisplay = ({ base64Image, accountId, isOnline }) => {
  const { state } = useContext(QRCodeContext);
  const { loading } = state
  const [isloading, setLoading] = useState(false);

  const send = (values) => {
    if (values.jid.split(',').length > 0) {
      values.jid.split(',').filter(e => e).reduce(async (a, b) => { 
        const cumul =  [...a]
        try {
          await wait(2000)
          cumul.push(await handleSendMessage({ ...values, jid: b }))
        } catch (e) {
         console.log(e.message||e)
          return cumul;
        }

      }, [])
    }
  }

  const handleSendMessage = async (values) => {
    setLoading(true)
    try {
      const response = await axios.post(`https://wa.coolendy.net/${accountId}/messages/send`, {
        jid: values.jid,
        message: values.message
      }, {
        headers: { "Content-Type": "application/json" }
      });
      setLoading(false)
      if (response.data.status === 'Message sent') {
        message.success('Message sent successfully');
      } else {
        message.error('Failed to send message');
      }
    } catch (error) {
      setLoading(false)
      message.error('Error sending message');
    }
    return 'done'
  };

  return (
    <div className="qrcode-background">
      <Card className="qrcode-card">
        {(!loading && !isOnline) && (
          <>
            <Title level={2}>Scan WhatsApp QR Code</Title>
            <Text>Veuillez scanner le QrCode pour vous connecter a WhatsApp.</Text>
          </>
        )}
        {(!loading && isOnline == true) && (
          <>
            <Title level={2}>Envoyer un message Test</Title>
          </>
        )}
        {loading && <Text>Chargement en cours...</Text>}
        {!isOnline && (<div className="qrcode-content">
          {loading ? <Spin size="large" /> : <img src={base64Image} alt="QR Code" style={{ width: '100%' }} />}
        </div>)}
        {(!loading && isOnline == true) && (
          <Form onFinish={send} className="message-form">
            <Form.Item name="jid" rules={[{ required: true, message: 'Please input the JID!' }]}>
              <Input placeholder="WhatsApp JID (phone number)" />
            </Form.Item>
            <Form.Item name="message" rules={[{ required: true, message: 'Please input the message!' }]}>
              <Input.TextArea placeholder="Message" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={isloading}>Send Message</Button>
            </Form.Item>
          </Form>
        )}
      </Card>
    </div>
  );
};

export default QRCodeDisplay;
